// @flow

import React from 'react';
import { Provider } from 'react-redux';
import ThemeProvider from '../ThemeProvider';
import TranslationsProvider from '../TranslationsProvider';

type ProvidersProps = {
  children: any,
  store: Object,
};

export default ({ children, store }: ProvidersProps) => (
  <Provider store={store}>
    <ThemeProvider>
      <TranslationsProvider>{children}</TranslationsProvider>
    </ThemeProvider>
  </Provider>
);
